export const PAYPAGE_MODE = 'paypage';
export const IFRAME_MODE = 'iframe';

export function getMode(): string {
  if (isIframeMode()) {
    return IFRAME_MODE;
  }

  return PAYPAGE_MODE; // Per default, the mode is paypage
}

export function getPayPageUri(evtId: string): string {
  return `${process.env.REACT_APP_URL_API_SIPS}/redirect?evtId=${evtId}`;
}

export function isIframeMode(): boolean {
  return 'iframe' === process.env.REACT_APP_SIPS_MODE;
}

export function getIframeUri(evtId: string): string {
  return `${process.env.REACT_APP_URL_API_SIPS}/redirect?evtId=${evtId}&iframe=true`;
}

export function getIframeOriginUri(): string {
  const envOrigin = process.env.REACT_APP_SIPS_IFRAME_POST_MESSAGE_ORIGIN;
  if (!envOrigin) {
    return window.location.origin;
  }

  return envOrigin;
}

export function getIframeActionName(): string {
  return 'sipsActionForm';
}
